import styled from 'styled-components/native';

const RowContainer = styled.View`
  display: flex;
  flex-direction: row;
`;

export default RowContainer;
